import React from 'react'
import MenuDropdownPost from './MenuDropdownPost'
import MenuDropdownList from './MenuDropdownList'
import MenuDropdownLayout from './MenuDropdownLayout'
import * as routes from '../../../constants/routes'
import {graphql, useStaticQuery} from 'gatsby'
import {useTranslation} from 'react-i18next'
import isPolishVersion from '../../../helpers/isPolishVersion'

const MenuKnowledge = () => {
    const imageData = useStaticQuery(graphql`
        {
            blog: file(relativePath: {eq: "images/menu/knowledge/blog.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            api: file(relativePath: {eq: "images/menu/knowledge/api.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            newsletter: file(relativePath: {eq: "images/menu/knowledge/newsletter.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            pressCentre: file(relativePath: {eq: "images/menu/knowledge/press-centre.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            documentation: file(relativePath: {eq: "images/menu/knowledge/documentation.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            ebooks: file(relativePath: {eq: "images/menu/knowledge/ebooks.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            caseStudies: file(relativePath: {eq: "images/menu/knowledge/case-studies.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            remoteWork: file(relativePath: {eq: "images/menu/knowledge/remote-work.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
            news: file(relativePath: {eq: "images/menu/knowledge/news.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                }
            }
        }
    `)
    const {t, i18n} = useTranslation()

    const menuItems = [
        {
            id: 'blog',
            title: t('menu_blog'),
            subtitle: t('menu_blog_description'),
            image: imageData.blog,
            href: routes.BLOG,
        },
        {
            id: 'ebooks',
            title: t('menu_ebooks'),
            subtitle: t('menu_ebooks_description'),
            image: imageData.ebooks,
            href: routes.EBOOKS,
        },
        {
            id: 'api',
            title: t('menu_api'),
            subtitle: t('menu_api_description'),
            href: routes.API,
            image: imageData.api,
        },
        {
            id: 'newsletter',
            title: t('menu_newsletter'),
            subtitle: t('menu_newsletter_description'),
            image: imageData.newsletter,
            href: routes.NEWSLETTER,
        },
        {
            id: 'press-centre',
            title: t('menu_press-centre'),
            subtitle: t('menu_press-centre_description'),
            image: imageData.pressCentre,
            href: routes.PRESS_CENTRE,
        },
        {
            id: 'documentation',
            title: t('menu_documentation'),
            subtitle: t('menu_documentation_description'),
            image: imageData.documentation,
            href: routes.DOCUMENTATION,
        },
        {
            id: 'case-studies',
            title: t('menu_case-study'),
            subtitle: t('menu_case-study_description'),
            image: imageData.caseStudies,
            href: routes.CASESTUDIES,
        },
        {
            id: 'remote-work',
            title: t('menu_remote-work'),
            subtitle: t('menu_remote-work_description'),
            image: imageData.remoteWork,
            href: routes.REMOTE_WORK,
        },
        {
            id: 'news',
            title: t('menu_news'),
            subtitle: t('menu_news_description'),
            image: imageData.news,
            href: routes.NEWS,
        },
    ]

    const menuItemsForLanguage = isPolishVersion(i18n.language)
        ? menuItems
        : menuItems.filter((item) => !['ebooks', 'newsletter'].includes(item.id))

    return (
        <MenuDropdownLayout>
            <MenuDropdownList items={menuItemsForLanguage} />
            <MenuDropdownPost menu={'knowledge'} />
        </MenuDropdownLayout>
    )
}

export default MenuKnowledge
